// import { GoogleGenerativeAI } from '@google/generative-ai';
// import Markdownkatexnew from "./Markdown.js";
import React, { useState } from 'react';
import axios from "axios"
import Select, { components } from 'react-select';
import { ToastContainer, toast } from 'react-toastify';

const Wwwww = [
  {value: 'gemini-3.5-flash', label: 'gemini-3.5-flash'},
  {value: 'gemini-3.1-flash-lite', label: 'gemini-3.1-flash-lite'},
  {value: 'veo-2.0-generate-001', label: 'veo-2.0-generate-001'},
  {value: 'gemini-3-flash-preview', label: 'gemini-3-flash-preview'},
  {value: 'gemini-3-pro-preview', label: 'gemini-3-pro-preview'},
  {value: 'gemini-2.5-flash-lite-preview-09-2025', label: 'gemini-2.5-flash-lite-preview-09-2025'},
  {value: 'gemini-2.5-flash-preview-09-2025', label: 'gemini-2.5-flash-preview-09-2025'},
  {value: 'gemini-2.5-flash-lite', label: 'gemini-2.5-flash-lite'},
  {value: 'gemini-2.5-pro-preview', label: 'gemini-2.5-pro-preview'},
  {value: 'gemini-2.5-pro-preview-05-06', label: 'gemini-2.5-pro-preview-05-06'},
  {value: 'gemini-2.5-flash', label: 'gemini-2.5-flash'},
  {value: 'gemini-2.5-pro', label: 'gemini-2.5-pro'},
  {value: 'gemini-2.0-flash', label: 'gemini-2.0-flash'},
  {value: 'gemini-2.0-flash-lite', label: 'gemini-2.0-flash-lite'},
];

const GeminiChat = ({ tittle, type }) => {
  const [prompt, setPrompt] = useState(tittle);
  const [model, setModel] = useState('gemini-3.5-flash');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (selectedOption) => {
    setModel(selectedOption.value);
  };

  // {value: 'gemini-3.5-flash', label: 'gemini-3.5-flash'},
  // {value: 'gemini-3.1-flash-lite', label: 'gemini-3.1-flash-lite'},
  // {value: 'gemini-3.1-pro-preview', label: 'gemini-3.1-pro-preview'},
  // {value: 'gemini-3-flash-preview', label: 'gemini-3-flash-preview'},
  // {value: 'gemini-3-pro-preview', label: 'gemini-3-pro-preview'},
  // {value: 'gemini-2.5-flash-lite-preview-09-2025', label: 'gemini-2.5-flash-lite-preview-09-2025'},
  // {value: 'gemini-2.5-flash-preview-09-2025', label: 'gemini-2.5-flash-preview-09-2025'},
  // {value: 'gemini-2.5-flash-lite', label: 'gemini-2.5-flash-lite'},
  // {value: 'gemini-2.5-pro-preview', label: 'gemini-2.5-pro-preview'},
  // {value: 'gemini-2.5-pro-preview-05-06', label: 'gemini-2.5-pro-preview-05-06'},
  // {value: 'gemini-2.5-flash', label: 'gemini-2.5-flash'},
  // {value: 'gemini-2.5-pro', label: 'gemini-2.5-pro'},
  // {value: 'gemini-2.0-flash', label: 'gemini-2.0-flash'},
  // {value: 'gemini-2.0-flash-lite', label: 'gemini-2.0-flash-lite'},
  // https://developer.puter.com/tutorials/free-gemini-api/#example-6-image-analysis

  const generarContenido = async () => {
    if (!prompt) return;
    setLoading(true);
    setResponse('');

    await axios.post(`${process.env.REACT_APP_API_URL}/users/userCr`, { prompt, model })
      .then((res) => {
        setResponse(res.data.response)
        console.log(res.data.response, "ai")
        setLoading(false);
      })
      .catch((err) => {
        // toast.error(err);
        console.log(err);
        // if (err.response.status === 401) {
        // }
      })


  };

  return (
    <div className=''>
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
      <div className=''>{model}
        <p style={{ marginBottom: "0em", marginTop: ".1em" }}>Modelo</p>
        <Select defaultValue={Wwwww.filter(({ value }) => value === model)} onChange={handleChange} options={Wwwww} disabled={loading} placeholder="Seleccione item" />

        <button type="submit" className='btn btn-warning text-center mt-1 w-100' disabled={loading}>
          {loading ? 'Pensando...' : 'Enviar'}
        </button>
      </div>
      {/*<input className="form-control" type="text" value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Escribe tu mensaje..." />*/}
      <button className="form-control btn btn-outline-info" onClick={generarContenido} disabled={loading}>
        {loading ? 'Pensando...' : `Enviar prompt ${type} asociado al tema`}
      </button>

      <div className=''>
        {/* <Markdownkatexnew>
          {response}
        </Markdownkatexnew> */}
        {response ? <textarea className="form-control" value={response} rows={8}></textarea> : ''}
      </div>
    </div>
  );
};

export default GeminiChat;
